import { Button, Modal, Space,message } from 'antd';
import React, { createContext } from 'react';
import { deleteBanner } from '../../../../api/api';
const ReachableContext = createContext(null);
const UnreachableContext = createContext(null);


const DeleteModal = (props) => {
    const [modal, contextHolder] = Modal.useModal();
  const {id,setIsFresh }= props
  const config = {
    title: '确定删除轮播图吗？',
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      deleteBanner(id).then(res=>{
        console.log(res);
        setIsFresh((pre)=>{
          return !pre
        })
      })
      message.success('删除轮播图成功！')
    },
  }

  return (
    <ReachableContext.Provider value="Light">
      <Space>
        <a       
          onClick={() => {
          modal.confirm(config);
          }}>
          删除
        </a>

      </Space>
      {/* `contextHolder` should always be placed under the context you want to access */}
      {contextHolder}

      {/* Can not access this context since `contextHolder` is not in it */}
      <UnreachableContext.Provider value="Bamboo" />
    </ReachableContext.Provider>
  );
};
export default DeleteModal;